import { useSelector } from 'react-redux';
import { filterSpecialtyTypesSelector } from '../../selectors/filters/filterSpecialtyTypesSelector';
import { IApplicationState } from '../../types/redux';

export function useFilterSpecialtyTypesSelector(): Array<number> {
  return useSelector<IApplicationState, Array<number>>(filterSpecialtyTypesSelector);
}
